export const EXPORT_TIME_FORMATS = Object.freeze({
  ISO_8601: "iso8601",
  EASY_READ: "MMMM d, yyyy, h:mm:ss a"
});
